if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      const boot = () => {
        if (this.booted) return;
        this.booted = true;
        this.performRecommendations();
      };

      // A hidden element (the fetch variant renders itself with class
      // "hidden"; only the fetch callback removes it) never intersects, so
      // deferring it would deadlock — boot those immediately like before.
      if (
        (window.Shopify && Shopify.designMode) ||
        !window.deferUntilNearViewport ||
        this.getClientRects().length === 0
      ) {
        boot();
      } else {
        window.deferUntilNearViewport(this, boot);
      }
    }

    performRecommendations() {
      const recommendations = this.querySelector(
        '[data-recommendations]'
      );
      if (!recommendations) return;

      if (this.dataset.staticContent === 'true') {
        if (!recommendations.children.length) return;
        this.classList.remove('hidden');
        this.initSlider();

        setTimeout(() => {
          if (document.querySelector('quick-cart-drawer')) {
            document.querySelector('quick-cart-drawer').init();
          } else {
            this.querySelectorAll('.quick-cart-drawer__trigger').forEach(el => {
              el?.remove();
            });
          }
        }, 500);
        return;
      }

      if (!this.dataset.url) return;
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const recommendationsHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-recommendations]')?.innerHTML;
          if (!recommendationsHTML) return;
          this.classList.remove('hidden');
          var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if(cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('.cart-drawer-items__full');
          }
          recommendations.innerHTML = recommendationsHTML;
          this.initSlider();

          // initiate quick cart after fetch
          // to activate trigger button events
          setTimeout(() => {
            if (document.querySelector("quick-cart-drawer")) {
              document.querySelector("quick-cart-drawer").init();
            } else {
              // if quick-cart-drawer does not exists, remove trigger buttons
              this.querySelectorAll(".quick-cart-drawer__trigger").forEach(el => {
                el?.remove();
              })
            }
          }, 500);

        });
    }

    initSlider() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 16,
        // Each slide is the product link itself; Swiper's default a11y would stamp it
        // role="group" aria-label="1 / 4", hiding the link role and the product name.
        a11y: { slideRole: null, slideLabelMessage: null },
      });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
